<template>
  <ion-page>
    <master-layout pageTitle="لیست خدمات">
      <ion-card>
        <ion-card-content>
          <DataTable auto-reload="1" :headers="headers" :route="'AllService/ListAjax'"></DataTable>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";

export default {
  data()
  {
    return {
      id:null,
      st : null,
      headers:[
        'عنوان',
        'دسته بندی',
        'قیمت پیش فرض',
      ]
    };
  },
  async created()
  {

  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage
  }
};
</script>

<style scoped>

</style>